import React from 'react';
import { Box } from '@dropbox/dig-foundations';
import { WordmarkLogo, SignWordmark } from '@dropbox/dig-logos';
import { WhiteLabelThemeProvider } from 'signer-app/white-labeling/theme-provider';
import { Footer } from 'signer-app/signer-experience/footer';
import { useBundleProps } from 'signer-app/bundle-props';
import styles from 'signer-app/signer-experience/auth-page-layout.module.css';

interface AuthPageLayoutProps {
  children: React.ReactNode;
  id?: string;
  hideFooter?: boolean;
}

export function AuthPageLayout({
  children,
  id,
  hideFooter,
}: AuthPageLayoutProps) {
  const { customLogoUri } = useBundleProps();

  return (
    <>
      <WhiteLabelThemeProvider mode="dark" colors="reset">
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          padding="Micro Small"
          backgroundColor="Background Subtle"
        >
          <Box color="Text Base" display="flex">
            {customLogoUri ? (
              <img
                src={customLogoUri}
                alt="Brand logo"
                style={{ height: '32px', width: 'auto', maxWidth: '200px' }}
              />
            ) : (
              <WordmarkLogo size={32} src={SignWordmark} />
            )}
          </Box>
        </Box>
      </WhiteLabelThemeProvider>
      <WhiteLabelThemeProvider mode="bright">
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          rowGap="Macro Medium"
          paddingX="Macro Small"
          className={styles.container}
          id={id}
        >
          {children}
        </Box>
        {!hideFooter && <Footer />}
      </WhiteLabelThemeProvider>
    </>
  );
}
